import React from "react";
import { SelectBox } from "devextreme-react";
import { useEffect } from "react";
import { setSubGridApiDefault } from "../../../../config/fetchApiConfig";
import { useDispatch, useSelector } from "react-redux";
import { SET_RECIPERANGE_EDIT } from "../../../../redux/actions/actionTypes";
import { useTranslation } from "react-i18next";

const AccountSelectBox = ({ setValue, value }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const recipeRangeState = useSelector((p) => p.RecipeRangeReducer);

  useEffect(() => {
    dispatch({
      type: SET_RECIPERANGE_EDIT,
      payload: { dataField: "selectedAccountId", value: value },
    });
  }, [value]);

  return (
    <SelectBox
      dataSource={setSubGridApiDefault(
        "Account",
        "id",
        "GetRelationList",
        null,
        null,
        null
      )}
      displayExpr="value"
      onValueChanged={({ value }) => {
        setValue && setValue(value.id);
        dispatch({
          type: SET_RECIPERANGE_EDIT,
          payload: { dataField: "selectedAccountId", value: value.id },
        });
        dispatch({
          type: SET_RECIPERANGE_EDIT,
          payload: { dataField: "selectedAccountFieldId", value: null },
        });
        dispatch({
          type: SET_RECIPERANGE_EDIT,
          payload: { dataField: "selectedCentralId", value: null },
        });
      }}
      searchEnabled={true}
      value={recipeRangeState.selectedAccountId ?? value}
      placeholder={t("selectCompany")}
    />
  );
};
export default AccountSelectBox;
